import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.MENUS}/menu-permissions`;

// GET /api/v3/menu-permissions/users/{userId}
// Response: [{ MenuId, Level, Description, Active }] — Active: 'B' | 'S' | 'N'
async function fetchUserPermissions(userId) {
  try {
    const response = await api.get(`${basePath}/users/${userId}`);

    const treated = errorHandling.handleResponse(
      response,
      "menuPermissionsService.fetchUserPermissions"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "menuPermissionsService.fetchUserPermissions");
    return null;
  }
}

// PUT /api/v3/menu-permissions/users/{userId}
// Body: { menuId, active } — active: 'S' | 'N'
async function updateUserPermission(userId, menuId, active) {
  try {
    const response = await api.put(`${basePath}/users/${userId}`, {
      menuId,
      active,
    });

    const treated = errorHandling.handleResponse(
      response,
      "menuPermissionsService.updateUserPermission"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "menuPermissionsService.updateUserPermission");
    return null;
  }
}

export const menuPermissionsService = {
  fetchUserPermissions,
  updateUserPermission,
};
